<template>
  <section class="refund" id="start">
    <div class="container">

      <!-- Header -->
      <div class="refund-header anim-item">
        <div class="badge">
          <i class="bi bi-arrow-counterclockwise"></i>
          Política de Reembolsos
        </div>
        <h1 class="refund-title">Política de<br />Reembolsos</h1>
        <p class="refund-meta">
          <i class="bi bi-building"></i> GST – Gestión Servicio Técnico
          <span class="dot">·</span>
          <i class="bi bi-envelope-fill"></i> contacto@gst.com.co
          <span class="dot">·</span>
          <i class="bi bi-telephone-fill"></i> +57 301 573 9461
          <span class="dot">·</span>
          <i class="bi bi-calendar3"></i> Última actualización: Marzo 2026
        </p>
        <p class="refund-intro">
          En <strong>GST – Gestión Servicio Técnico</strong> nos comprometemos a garantizar la
          satisfacción de nuestros clientes. Nuestra política de reembolsos ha sido diseñada para
          ser justa y transparente, asegurando que tu experiencia con nuestra plataforma sea
          confiable y satisfactoria.
        </p>
      </div>

      <!-- Alerta exclusión -->
      <div class="exclusion-alert anim-item">
        <div class="exclusion-alert-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
        <div class="exclusion-alert-body">
          <h3 class="exclusion-alert-title">Exclusión Importante</h3>
          <p>
            Esta política aplica <strong>únicamente</strong> a los planes de suscripción y
            almacenamiento adicional contratados a través de la plataforma GST.
            Quedan <strong>excluidos</strong>:
          </p>
          <ul class="exclusion-list">
            <li><i class="bi bi-x-circle-fill"></i> Períodos de suscripción ya vencidos o consumidos parcialmente</li>
            <li><i class="bi bi-x-circle-fill"></i> Almacenamiento adicional utilizado durante el período de facturación</li>
            <li><i class="bi bi-x-circle-fill"></i> Servicios de soporte técnico especializado ya ejecutados</li>
            <li><i class="bi bi-x-circle-fill"></i> Promociones o descuentos bajo condiciones especiales, salvo indicación contraria</li>
          </ul>
        </div>
      </div>

      <!-- Sections -->
      <div class="sections">

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-check2-circle"></i></div>
          <div class="section-body">
            <h2 class="section-title">1. Elegibilidad para Reembolso</h2>
            <p>Los reembolsos se considerarán en los siguientes casos:</p>
            <ul class="check-list">
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <span><strong>Error en la contratación:</strong> si contrataste un plan superior al necesario y lo notificas dentro de los primeros 5 días hábiles.</span>
              </li>
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <span><strong>Cancelación antes del inicio:</strong> si cancelas la suscripción antes de que comience el período de facturación.</span>
              </li>
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <span><strong>Problemas técnicos no resueltos:</strong> fallas graves imputables a la plataforma no resueltas en 7 días hábiles.</span>
              </li>
              <li>
                <i class="bi bi-check-circle-fill"></i>
                <span><strong>Cobro no autorizado o duplicado:</strong> cargo indebido o duplicado en tu método de pago.</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-clipboard2-check-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">2. Condiciones para Reembolso</h2>
            <ul class="check-list">
              <li>
                <i class="bi bi-info-circle-fill"></i>
                <span><strong>Planes de suscripción:</strong> notificación dentro de los primeros 5 días hábiles. No se realizan reembolsos parciales por días no utilizados.</span>
              </li>
              <li>
                <i class="bi bi-info-circle-fill"></i>
                <span><strong>Almacenamiento adicional:</strong> no se reembolsa el almacenamiento ya consumido. La desactivación aplica para el siguiente ciclo.</span>
              </li>
              <li>
                <i class="bi bi-info-circle-fill"></i>
                <span><strong>Cancelación de suscripción:</strong> si cancelas después de iniciado el período, no aplica reembolso, pero conservas acceso hasta el final del período pagado.</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-diagram-3-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">3. Proceso de Reembolso</h2>
            <div class="steps">
              <div class="step">
                <div class="step-num">1</div>
                <div class="step-body">
                  <strong>Notificación</strong>
                  <p>Contacta a nuestro equipo en <a href="mailto:contacto@gst.com.co">contacto@gst.com.co</a> o al <a href="tel:+573015739461">+57 301 573 9461</a>, indicando el motivo y el número de referencia de tu pago.</p>
                </div>
              </div>
              <div class="step">
                <div class="step-num">2</div>
                <div class="step-body">
                  <strong>Revisión</strong>
                  <p>Evaluaremos tu solicitud en máximo 3 días hábiles. Si es necesario, solicitaremos evidencias adicionales.</p>
                </div>
              </div>
              <div class="step">
                <div class="step-num">3</div>
                <div class="step-body">
                  <strong>Verificación</strong>
                  <p>Una vez aprobada la solicitud, verificaremos los datos de tu método de pago original.</p>
                </div>
              </div>
              <div class="step">
                <div class="step-num">4</div>
                <div class="step-body">
                  <strong>Reembolso</strong>
                  <p>Procederemos al reembolso por el mismo método de pago. En casos excepcionales, podremos ofrecer un crédito en plataforma.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-hourglass-split"></i></div>
          <div class="section-body">
            <h2 class="section-title">4. Tiempo de Procesamiento</h2>
            <p>
              El tiempo de procesamiento puede variar según el método de pago, pero generalmente
              se completa dentro de los <strong>10 a 15 días hábiles</strong> posteriores a la
              aprobación de la solicitud.
            </p>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-bank2"></i></div>
          <div class="section-body">
            <h2 class="section-title">5. Gastos de Transacción</h2>
            <p>
              Los gastos de transacción o comisiones bancarias asociadas al pago original
              <strong>no serán reembolsables</strong>, a menos que el reembolso sea debido a un
              error comprobado por parte de OPERACION SISTEMICA SAS.
            </p>
          </div>
        </div>

        <div class="section-card">
          <div class="section-icon"><i class="bi bi-slash-circle-fill"></i></div>
          <div class="section-body">
            <h2 class="section-title">6. Excepciones</h2>
            <p>No serán elegibles para reembolso:</p>
            <ul class="exclusion-list">
              <li><i class="bi bi-x-circle-fill"></i> Planes contratados bajo promociones especiales con descuento no reembolsable</li>
              <li><i class="bi bi-x-circle-fill"></i> Suscripciones anuales una vez superado el período de 5 días hábiles desde el pago</li>
              <li><i class="bi bi-x-circle-fill"></i> Almacenamiento adicional utilizado durante el ciclo de facturación actual</li>
            </ul>
          </div>
        </div>

        <div class="section-card section-card--last">
          <div class="section-icon"><i class="bi bi-pencil-square"></i></div>
          <div class="section-body">
            <h2 class="section-title">7. Cambios en la Política</h2>
            <p>
              OPERACION SISTEMICA SAS se reserva el derecho de modificar esta política en cualquier
              momento. Los cambios serán comunicados en el sitio web y en la plataforma GST, y
              aplicarán a partir de su publicación.
            </p>
          </div>
        </div>

      </div>

      <!-- Contact CTA -->
      <div class="contact-cta anim-item">
        <i class="bi bi-chat-dots-fill"></i>
        <div>
          <strong>¿Tienes dudas sobre nuestra política de reembolsos?</strong>
          <p>Contáctanos en <a href="mailto:contacto@gst.com.co">contacto@gst.com.co</a> o al <a href="tel:+573015739461">+57 301 573 9461</a>. Estamos aquí para ayudarte.</p>
        </div>
      </div>

      <!-- Footer note -->
      <div class="refund-footer anim-item">
        <i class="bi bi-building"></i>
        <span>OPERACION SISTEMICA SAS · NIT 901227220-8 · © 2019–2026 GST. Todos los derechos reservados.</span>
      </div>

    </div>
  </section>
</template>

<script setup>
import { defineProps } from 'vue'
import { useRoute } from 'vue-router'

defineProps({ darkMode: Boolean })

const route = useRoute()

import { onMounted, nextTick } from 'vue'
onMounted(() => {
  nextTick(() => {
    if (route.hash) {
      const id = route.hash.replace('#', '')
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ block: 'start' })
      }
    }
  })
})
</script>

<style scoped>
.refund {
  min-height: 100vh;
  background: var(--bg);
  padding: 5rem 0 4rem;
  transition: background 0.35s;
}

.container {
  max-width: 860px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* ══ HEADER ══ */
.refund-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  color: var(--accent);
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.35rem 0.9rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
}

.refund-title {
  font-size: clamp(1.8rem, 4vw, 3rem);
  font-weight: 900;
  letter-spacing: -0.04em;
  line-height: 1.15;
  color: var(--text);
  margin-bottom: 1rem;
  transition: color 0.35s;
}

.refund-meta {
  font-size: 0.85rem;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  transition: color 0.35s;
}

.refund-meta i { color: var(--accent); }
.dot { opacity: 0.4; }

.refund-intro {
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.7;
  max-width: 640px;
  margin: 0 auto;
  background: var(--bg-card);
  border: 1px solid var(--border-soft);
  border-radius: 1rem;
  padding: 1.25rem 1.5rem;
  transition: background 0.35s, border-color 0.35s, color 0.35s;
}

/* ══ EXCLUSION ALERT ══ */
.exclusion-alert {
  display: flex;
  gap: 1.25rem;
  background: rgba(239, 68, 68, 0.06);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 1.25rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.exclusion-alert-icon {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: #ef4444;
}

.exclusion-alert-body { flex: 1; }

.exclusion-alert-title {
  font-size: 1rem;
  font-weight: 800;
  color: var(--text);
  margin-bottom: 0.5rem;
  transition: color 0.35s;
}

.exclusion-alert-body p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.6;
  margin-bottom: 0.75rem;
  transition: color 0.35s;
}

/* ══ SECTIONS ══ */
.sections {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-bottom: 2rem;
}

.section-card {
  display: flex;
  gap: 1.5rem;
  background: var(--bg-card);
  border: 1px solid var(--border-soft);
  border-radius: 1.25rem;
  padding: 1.75rem;
  transition: background 0.35s, border-color 0.35s;
}

.section-card--last {
  border-color: var(--accent);
  box-shadow: 0 0 0 1px var(--accent), 0 4px 24px var(--accent-glow);
}

.section-icon {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  background: var(--border-soft);
  border: 1px solid var(--border);
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--accent);
  transition: background 0.35s, border-color 0.35s;
}

.section-body { flex: 1; }

.section-title {
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--text);
  margin-bottom: 0.75rem;
  letter-spacing: -0.02em;
  transition: color 0.35s;
}

.section-body > p {
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.7;
  margin-bottom: 0.75rem;
  transition: color 0.35s;
}

/* ══ CHECK LIST ══ */
.check-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.check-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
  transition: color 0.35s;
}

.check-list li i {
  color: var(--accent);
  font-size: 0.95rem;
  flex-shrink: 0;
  margin-top: 0.15rem;
}

/* ══ EXCLUSION LIST ══ */
.exclusion-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.exclusion-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.88rem;
  color: var(--text-muted);
  line-height: 1.5;
  transition: color 0.35s;
}

.exclusion-list li i {
  color: #ef4444;
  font-size: 0.9rem;
  flex-shrink: 0;
  margin-top: 0.15rem;
}

/* ══ STEPS ══ */
.steps {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 0.5rem;
}

.step {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.step-num {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  background: var(--accent);
  color: var(--accent-text);
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  font-weight: 900;
}

.step-body strong {
  display: block;
  font-size: 0.9rem;
  color: var(--text);
  margin-bottom: 0.2rem;
  transition: color 0.35s;
}

.step-body p {
  font-size: 0.85rem;
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0;
  transition: color 0.35s;
}

.step-body a {
  color: var(--accent);
  text-decoration: none;
  font-weight: 600;
}

.step-body a:hover { text-decoration: underline; }

/* ══ CONTACT CTA ══ */
.contact-cta {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  background: var(--bg-card);
  border: 1px solid var(--accent);
  box-shadow: 0 0 0 1px var(--accent), 0 4px 24px var(--accent-glow);
  border-radius: 1.25rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.contact-cta > i {
  font-size: 1.8rem;
  color: var(--accent);
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.contact-cta strong {
  display: block;
  font-size: 0.95rem;
  color: var(--text);
  margin-bottom: 0.3rem;
  transition: color 0.35s;
}

.contact-cta p {
  font-size: 0.88rem;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.6;
  transition: color 0.35s;
}

.contact-cta a {
  color: var(--accent);
  font-weight: 600;
  text-decoration: none;
}

.contact-cta a:hover { text-decoration: underline; }

/* ══ FOOTER NOTE ══ */
.refund-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.78rem;
  color: var(--text-muted);
  text-align: center;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-light);
  transition: color 0.35s, border-color 0.35s;
}

.refund-footer i { color: var(--accent); }

/* ══ RESPONSIVE ══ */
@media (max-width: 640px) {
  .refund { padding: 3rem 0 2rem; }
  .container { padding: 0 1rem; }

  .section-card, .exclusion-alert, .contact-cta {
    flex-direction: column;
    gap: 1rem;
    padding: 1.25rem;
  }

  .section-card, .exclusion-alert, .contact-cta { align-items: center; text-align: center; }
  .section-icon, .exclusion-alert-icon { width: 2.5rem; height: 2.5rem; font-size: 1.1rem; align-self: center; }
  .section-body { text-align: center; }
  .exclusion-list, .check-list { text-align: left; }
  .exclusion-list li, .check-list li { display: block; padding-left: 1.5rem; position: relative; }
  .exclusion-list li i, .check-list li i { position: absolute; left: 0; top: 0.2rem; }
  .steps .step { flex-direction: column; align-items: center; text-align: center; }
  .refund-title { font-size: clamp(1.5rem, 7vw, 1.8rem); }
  .refund-intro { padding: 1rem; font-size: 0.88rem; }
  .refund-meta { font-size: 0.78rem; }
}

/* ══ PANTALLAS GRANDES ══ */
@media (min-width: 1400px) {
  .container { max-width: 1100px; }
}

@media (min-width: 1920px) {
  .container { max-width: 1300px; }
}

@media (min-width: 2560px) {
  .container { max-width: 1600px; }
}
</style>